module.exports = "<p>\n  scoring works!\n</p>\n\n<p>{{attemptCount}}</p>\n<p>{{correctCount}}</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/scoring/scoring.component.html
// module id = ../../../../../src/app/scoring/scoring.component.html
// module chunks = main